import React from 'react';
import { Download, ExternalLink, Newspaper } from 'lucide-react';

const Press = () => {
    const releases = [
        { date: "Nov 2025", title: "Hue alcanza 50 municipios en Chile", source: "Diario Financiero" },
        { date: "Oct 2025", title: "La app que revoluciona la gestión municipal", source: "La Tercera" },
        { date: "Sep 2025", title: "Hue levanta ronda semilla para expansión", source: "Startups Latam" },
    ];

    return (
        <div className="min-h-screen bg-white font-roboto text-slate-900 pb-20">
            {/* Hero */}
            <div className="bg-slate-900 text-white py-20 px-6 rounded-b-[3rem]">
                <div className="max-w-4xl mx-auto text-center">
                    <h1 className="text-4xl md:text-6xl font-black mb-6">Sala de Prensa</h1>
                    <p className="text-xl text-slate-400 max-w-2xl mx-auto">
                        Noticias, recursos de marca y contacto para medios.
                    </p>
                </div>
            </div>

            <div className="max-w-6xl mx-auto px-6 py-16">
                <div className="grid md:grid-cols-3 gap-12">
                    {/* Press Releases */}
                    <div className="md:col-span-2 space-y-8">
                        <h2 className="text-2xl font-bold mb-6 flex items-center gap-2">
                            <Newspaper className="text-hue-purple" />
                            Últimas Noticias
                        </h2>
                        {releases.map((item, idx) => (
                            <div key={idx} className="bg-slate-50 p-6 rounded-2xl border border-slate-100 hover:shadow-md transition group cursor-pointer">
                                <div className="flex justify-between items-start mb-2">
                                    <span className="text-sm font-bold text-hue-purple uppercase tracking-wider">{item.source}</span>
                                    <span className="text-slate-400 text-sm">{item.date}</span>
                                </div>
                                <h3 className="text-xl font-bold group-hover:text-hue-purple transition">{item.title}</h3>
                                <div className="mt-4 flex items-center text-sm text-slate-500 font-medium">
                                    Leer artículo <ExternalLink size={16} className="ml-1" />
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Media Kit */}
                    <div className="space-y-8">
                        <div className="bg-hue-bg p-8 rounded-[2rem]">
                            <h3 className="text-xl font-bold mb-4">Kit de Prensa</h3>
                            <p className="text-slate-600 mb-6 text-sm">
                                Descarga nuestros logos oficiales, capturas de pantalla y fotos del equipo en alta resolución.
                            </p>
                            <button className="w-full bg-slate-900 text-white py-3 rounded-xl font-bold flex items-center justify-center gap-2 hover:bg-slate-800 transition">
                                <Download size={18} />
                                Descargar Assets (ZIP)
                            </button>
                        </div>

                        <div className="p-8 rounded-[2rem] border border-slate-200">
                            <h3 className="text-xl font-bold mb-4">Contacto de Prensa</h3>
                            <p className="text-slate-600 mb-2 text-sm">Para consultas de medios:</p>
                            <a href="mailto:prensa@hue.cl" className="text-hue-purple font-bold hover:underline">prensa@hue.cl</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Press;
